import styled from "@emotion/styled";
import { Grid } from "@mantine/core";

interface StyledGridColProps {
  align?: string;
  justify?: string;
  textAlign?: string;
}

export const StyledGridCol = styled(Grid.Col)<StyledGridColProps>`
  display: flex;
  align-items: ${({ align }) => align ?? "start"};
  justify-content: ${({ justify }) => justify ?? "start"};
  text-align: ${({ textAlign }) => textAlign};
`;
